import useScriptLoader from '~/composables/useScriptLoader'

const SCRIPTS = {
	html2pdf: 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.9.3/html2pdf.bundle.min.js'
}

const defaultOptions = {
	margin: [0.4, 0.3],
	image: { type: 'jpeg', quality: 0.98 },
	pagebreak: { mode: 'css' },
	enableLinks: true,
	html2canvas: { scale: 2, useCORS: true },
	jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
}

export function useGeneratePDF() {
	const { loadScript, scriptIsLoaded } = useScriptLoader()

	async function generatePDFBlob(pdfContent: any, pdfOptions = {}): Promise<any> {
		if (scriptIsLoaded.value) {
			try {
				const html2PdfSetup = window
					//@ts-ignore
					.html2pdf()
					.set({ ...defaultOptions, ...pdfOptions })
					.from(pdfContent)
					.save()
				const blobUrl = await html2PdfSetup.output('bloburl')
				const res = await fetch(blobUrl)
				return await res.blob()
			} catch (error) {
				console.error('error >>>>', error)
			}
		} else {
			useNotification().alert({
				status: 400,
				message: 'Error generating a receipt. Please try again later.'
			})
		}
	}

	onMounted(() => {
		if (import.meta.client) {
			loadScript(SCRIPTS.html2pdf)
		}
	})

	return {
		generatePDFBlob
	}
}
